export default __webpack_public_path__ + "media/images/borders/blue-border-b1cd1cd7fe1ed91adc32dd2581de6bd5.svg";